
    import moment from 'moment';
    import typy from "typy"
    import FormComponent from '../sms/form.component.vue';
    import { generateMonthsColumns } from '../../../checkin-facility/utils/helpers';

    export default {
        components: {
            FormComponent,
        },
        data() {
            return {
                filter: {
                    year: new Date().getFullYear(),
                },
                paginationTexts: {
                    texts: {
                        count: "Showing {from} to {to} of {count} records| {count} records| 1 record",
                    }
                },
    
                config: {
                    facilityName: 'Select Facility',
                    checked_in_collapsed: 0,
                    checked_out_collapsed: 0
                },
                daysOfMonth: [],
                data: {
                    current_page: 1,
                    per_page: 10,
                    total: 0,
                    data: [], 
                },
                facility: {},
                years: [],
                searchQuery: '', 
                selectedFacility: {}, 
                showAllocateModal: false,
                error: '',
                modalType: '',
                months: [],
                facilityData: {}
            };
        },
        
        async mounted() {
            this.months = generateMonthsColumns(-1, 12);
            await this.fetchFacilities();
        },
        computed: {
            filteredFacilities() {
                if (this.searchQuery.trim() === '') {
                    return this.data.data; 
                }

                return this.data.data.filter(sms =>
                    sms.facility_name.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            },
            },
        methods: {
            async search() {
                await this.list({ page: 1, per_page: this.data.per_page });
            },

            async paginate(page) {
                var filter = {
                    page: page,
                };
                await this.list(filter);
            },

            async list(data) {
                try {
                    const response = await this.$lionheart.get('/v2/facility/sms/admin/facilities', 
                        { params: { ...data, facility_name: this.searchQuery }});
                        this.data = response.data.data;
                    } catch (error) {
                        console.error('Error fetching facilities:', error);
                    }
                },

            async fetchFacilities() {
                await this.list({ page: this.data.current_page, per_page: this.data.per_page });
            },

            clearData() {
                this.error = '';
                this.config.facilityName = this.$t('sms-control.select_facility');
                this.searchQuery = "";
            },

            handleYear() {
                this.clearData();
            },

            closeAnalyticsModal() {
                this.$bvModal.hide('sms-inventory');
            },

            openAllocateModal(val) {
                this.selectedFacility = val;
                this.$bvModal.show('sms-inventory')
            }
        }
    }